/**
 * Crop shapes Tammy can pick before upload.
 * Square matches menu cards. Original (undefined) leaves the file uncropped.
 */

export type CropAspectId = 'square' | 'landscape' | 'portrait' | 'wide' | 'original';

export interface CropAspectPreset {
  id: CropAspectId;
  label: string;
  /** react-easy-crop aspect; omit for free / original file */
  value?: number;
}

export const CROP_ASPECT_PRESETS: CropAspectPreset[] = [
  { id: 'square', label: 'Square', value: 1 },
  { id: 'landscape', label: 'Landscape', value: 4 / 3 },
  { id: 'portrait', label: 'Portrait', value: 3 / 4 },
  { id: 'wide', label: 'Wide', value: 16 / 9 },
  { id: 'original', label: 'Original' },
];

/** Map ImageSelector previewAspect (or a numeric crop) to a preset id. */
export function cropPresetIdForAspect(aspect?: number): CropAspectId {
  if (aspect == null || Number.isNaN(aspect)) return 'original';
  if (Math.abs(aspect - 1) < 0.01) return 'square';
  if (Math.abs(aspect - 4 / 3) < 0.01) return 'landscape';
  if (Math.abs(aspect - 3 / 4) < 0.01) return 'portrait';
  if (Math.abs(aspect - 16 / 9) < 0.01) return 'wide';
  if (Math.abs(aspect - 21 / 9) < 0.05) return 'wide';
  return 'square';
}

export function cropAspectValue(id: CropAspectId): number | undefined {
  return CROP_ASPECT_PRESETS.find((p) => p.id === id)?.value;
}
